import React, { useContext } from 'react';
import { Alert, Text, ArrowLink, Spacer } from 'react-onei';
import { Link } from 'react-router-dom';

import UserContext from '../../../../context/UserContext';

import TagService from '../../../../services/TagService';
import { events } from '../../../../conf/tags_ga.conf';

const NewTemporaryPassword = () => {
    const { wording, setStep } = useContext(UserContext);
    const { WLOST_210, WLOST_211, WLOST_212, WLOST_213 } = wording;

    function handleClick() {
        setStep('/letter');
        TagService.sendEvent(events.getLetter);
    };

    return (
        <div className="spacing-xs">
            <Text variant="lead" id="get-letter-label">
                <strong>
                    {WLOST_210}
                </strong>
            </Text>
            <Text id="get-letter-delay">
                {WLOST_211}
            </Text>
            <ArrowLink
                href=""
                as={Link}
                to="/letter"
                id="get-letter-link"
                onClick={handleClick}
                aria-label={WLOST_212}
                title={WLOST_212}
                fullWidth
            >
                {WLOST_212}
            </ArrowLink>
            <Alert
                id="sav-letter-message"
                mini
                variant="info"
                title={WLOST_213}
                className="spacing-xs"
            />
            <Spacer color="grey4" className="spacing-xs" />
        </div>
    )
};

export default NewTemporaryPassword;